import { Component, OnInit } from '@angular/core';
import { debounce } from 'lodash-decorators';
import { SelectItem } from 'primeng/api';
import { NotificationService } from 'src/app/shared';
import { ImportRegistrationService } from '../../registration/shared/import-registration.service';
import { EventItemService } from '../../shared/items/event-item.service';
import { ImportRegistrationsConfigDto } from './import-registations-config.dto';

@Component({
  selector: 'wl-import-registations',
  templateUrl: './import-registations.component.html',
  styleUrls: ['./import-registations.component.less'],
    standalone: false
})
export class ImportRegistationsComponent implements OnInit {
  notificationEmails = [{ value: '' } as SelectItem]; // this will probably tie to a dto at some point
  downloadUrl = 'https://s3.us-east-2.amazonaws.com/atlas.unrestricted/templates/EventAttendeeImport.xlsx';
  importConfig: ImportRegistrationsConfigDto;
  eventItemOptions: Array<SelectItem>;
  optionsRan = false;
  fileSelected: boolean;
  file: File;
  importStarted = false;

  constructor(
    private _eventItemService: EventItemService,
    private _importRegistraionService: ImportRegistrationService,
    private _notificationService: NotificationService
  ) {
    this.importConfig = {} as ImportRegistrationsConfigDto;
  }

  ngOnInit(): void {}

  selectFile($event) {
    this.fileSelected = !!$event.files[0].name;
    this.file = $event.currentFiles[0];
  }

  removeFile() {
    this.fileSelected = false;
  }

  @debounce(500)
  eventIdChanged() {
    this.importConfig.DefaultEventItemId = null;
    if (this.importConfig.EventId > 0) {
      this._eventItemService.getEventItems(this.importConfig.EventId).then((data) => {
        this.optionsRan = true;
        this.eventItemOptions = data.map((x) => {
          return { label: x.Descr, value: x.EventItemId } as SelectItem;
        });
        this.importConfig.DefaultEventItemId = data[0]?.EventItemId;
      });
    } else {
      this.eventItemOptions = [];
    }
  }

  addEmail() {
    this.notificationEmails.push({ value: '' });
  }

  removeEmail(i) {
    this.notificationEmails.splice(i, 1);
  }

  importRegistrations() {
    this.importStarted = true;
    this.importConfig.NotificationEmails = this.notificationEmails.filter((x) => !!x.value).map((x) => x.value);
    this._importRegistraionService
      .importRegistrations(this.file, this.importConfig)
      .then(() => {
        this._notificationService.translateSuccess('events.registration-import.import-started');
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  downloadTemplate() {
    window.open(this.downloadUrl, '_blank');
  }
}
